import {numericality, length} from '../units';
import validate from '../common';

const validations = () => ({
  code: [length({is: 6}), numericality()]
});

export default () => ({
  validate: validate(validations())
});



// WEBPACK FOOTER //
// ./validators/forms/otp.js